<template>
<div><v-dialog hide-overlay  id="overlay"></v-dialog></div>


</template>


<style>
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0; 
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #FFFFFF;
  opacity: 0.5;
  z-index: 2;

}
</style>

<script>
  export default {
    data () {
      return {
        // dialog: true
      }
    
    }
    // , 
    // props: ['isloading'],
  }
</script>